/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ObstetricEvent from './obstetric-event';
import ObstetricEventDetail from './obstetric-event-detail';
import ObstetricEventUpdate from './obstetric-event-update';
import ObstetricEventDeleteDialog from './obstetric-event-delete-dialog';

const ObstetricEventRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ObstetricEvent />} />
    <Route path="new" element={<ObstetricEventUpdate />} />
    <Route path=":id">
      <Route index element={<ObstetricEventDetail />} />
      <Route path="edit" element={<ObstetricEventUpdate />} />
      <Route path="delete" element={<ObstetricEventDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ObstetricEventRoutes;
